import { createFileRoute, redirect } from "@tanstack/react-router";
import { ComparisonTemplateForm } from "@/features/comparison-templates/ComparisonTemplateForm";
import { canCreatePurchaseIndent } from "@/lib/roles";
import { currentUserQueryOptions } from "@/hooks/useCurrentUser";

export const Route = createFileRoute("/_authenticated/quotation-comparison-templates/new")({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(currentUserQueryOptions());
    if (!canCreatePurchaseIndent(me.roles)) throw redirect({ to: "/quotation-comparison-templates" });
  },
  component: NewComparisonTemplate,
});

function NewComparisonTemplate() {
  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">New Comparison Template</h1>
      <ComparisonTemplateForm />
    </div>
  );
}
